import React from 'react';
import { motion } from 'framer-motion';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/miKeNXnKoUZ4pNJ3m9H5UE/PNG-website-file-dark-Transparent-background.png';
export function Header() {
  return <header className="w-full bg-navy py-8 px-4" data-id="element-15">
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-16">
        <img src={LOGO_URL} alt="Start Launching Creatives" className="w-48 md:w-64 mb-4" data-id="element-17" />
        <p className="text-red font-oswald text-sm md:text-base tracking-widest uppercase leading-relaxed" data-id="element-18">
          Conecta. Vende. Lanza.
          <br data-id="element-19" />
          Sin aparecer en cámara y sin complicaciones
        </p>
      </motion.div>
    </header>;
}